/**
 * Loại Control
 */
 export default {
    Text: 1,
    Combobox: 2,
    Number: 3,
    Checkbox: 4,
    Datepicker: 5,
    Dropdown: 6,
    Template: 7,
    TextArea: 8,
    Enum: 9,
    ComboboxMultiple: 10,
    DateRange: 11,
  };
  